import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatepickerModalComponent } from '../datepicker-modal/datepicker-modal.component';
import { FlightPickerModalComponent } from '../flightpicker-modal/flightpicker-modal.component';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { set } from 'date-fns'
import { FormService } from '../organizations/features/booking/components/form/service';
import { ParkingRepo } from '../repo/parking.repo';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { BookingConfigService } from '../services/booking-config.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Booking, INIT_DATA } from '../../models/orderModel';
import { BookingConfig, BookingConfigType, ShuttleConfig, BOOKING_CONFIG_QUALITY, BOOKING_CONFIG_AIDEN, filterTerminalsByDate } from '../../models/BookingModel';
import { PlannedShuttleBuss } from '../../models/ShuttleBookingModel';
import { ShuttelbussService } from '../../services/shuttlebuss.service';
import moment from 'moment';

@Component({
  selector: 'app-parking-and-transfer-picker-modal',
  imports: [
    DatePipe,
    MatMenuModule,
    TranslocoModule,
    CommonModule,
    FormsModule,
  ],
  templateUrl: './parking-and-transfer-picker-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parking-and-transfer-picker-modal.component.css'
})
export class ParkingAndTransferPickerModalComponent {

  selectedTime: string = "00:00";
  selectedDate: Date | null = null;
  selectedHotel: string = '';
  selectedHotelDisplay: string = '';
  selectedHotelDate: Date | null = null;
  selectedHotelTime: Date | null = null;
  selectedHotelLocation: string = '';
  selectedFlight: any;
  showHotel: boolean = false;
  parkingArrivalTimeText: string = '';
  ShuttleHotelTimeText: string = '';
  ShuttleAirportTimeText: string = '';
  @Input() searchData: any | null = null;
  hotelOptions: any = [];
  @Input({ required: true }) type: string = '';
  @ViewChild(MatMenuTrigger)
  timeMenuBtn!: MatMenuTrigger;
  arriveAtParkingOptions: any = [];
  site: string = '';
  hotelName: string = 'Quality Hotel Arlanda XPO';

  bundle: Booking = INIT_DATA;
  bookingConfig: BookingConfig;
  bookingConfigType: BookingConfigType;
  useFlightForArrival = true;

  bookingConfigQuality: BookingConfig = BOOKING_CONFIG_QUALITY;
  bookingConfigAiden: BookingConfig = BOOKING_CONFIG_AIDEN;

  bookingConfigShuttleArrival: ShuttleConfig;
  bookingConfigShuttleDeparture: ShuttleConfig;
  plannedShuttleBussesDeparture: PlannedShuttleBuss[] = [];
  plannedShuttleBussesArrival: PlannedShuttleBuss[] = [];
  selectedShuttleBus: any = '';
  selectedDepartureDateForTransfer: Date | null = null;
  selectedParkingEndDate: Date | null = null;
  selectedPassengers: number = 0;
  selectedShuttleBusDeparture: any = '';
  selectedShuttleBusArrival: any = '';
  passengerOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8];
  selectedTerminal: any = null;
  showParkingEndDate: boolean = true;
  parkingStartDate: Date | null = null;
  selectedParkingStartDate: any = '';

  constructor(
    public dialog: MatDialog,
    private _formService: FormService,
    private _parkingRepo: ParkingRepo,
    private _datePipe: DatePipe,
    private http: HttpClient,
    private bookingConfigService: BookingConfigService,
    public shuttleBussService: ShuttelbussService,
    private snackBar: MatSnackBar
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  ngOnInit(): void {
    if (this.site == "quality hotel arlanda xpo parkering" || this.site == "quality-xpo-arlanda" || this.site == "quality") {
      this.getOrganizationConfig('39218780-069A-4C6B-9925-22365A075C15');
    } else if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
      this.getOrganizationConfig('D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251');
      this.hotelName = 'Aiden Hotel Arlanda';
    }
    if (this.type === 'arrival') {
      const form = this._formService.getForm();
      const hotelsGroup = form?.get('hotels');
      if (hotelsGroup) {
        hotelsGroup.get('departureFlightDate')?.valueChanges.subscribe(() => {
          this.checkAndResetArrivalFields();
        });

        hotelsGroup.get('departureDatetime')?.valueChanges.subscribe(() => {
          this.checkAndResetArrivalFields();
        });

        hotelsGroup.get('departureDatetimeForTransfer')?.valueChanges.subscribe(() => {
          this.checkAndResetArrivalFields();
        });
      }

      const searchGroup = form?.get('search');
      if (searchGroup) {
        searchGroup.get('isDepartureHotel')?.valueChanges.subscribe(() => {
          this.checkAndResetArrivalFields();
        });
      }
    }

    if (this.searchData) {

      if (this.type === 'departure') {
        this.showHotel = this.searchData?.isDepartureHotel ?? false;
        this.selectedPassengers = this.searchData?.departurePassengers;
        this.selectedTerminal = this.searchData?.departureTerminal;
        this.selectedFlight = this.searchData?.departureFlight;
        const depDateVal = this.searchData?.departureFlightDate || this.searchData?.departureDate;
        this.selectedDate = depDateVal ? new Date(depDateVal) : null;
        this.selectedHotelDate = this.searchData?.departureDatetime ? new Date(this.searchData?.departureDatetime) : null;
        this.selectedDepartureDateForTransfer = this.searchData?.departureDatetimeForTransfer ? new Date(this.searchData?.departureDatetimeForTransfer) : null;
        this.parkingStartDate = this.searchData?.parkingStartDate ? new Date(this.searchData?.parkingStartDate) : null;

        // Deserialize departureRoute back to Moment object if it comes as string
        const departureRoute = this.searchData?.departureRoute;
        this.selectedShuttleBusDeparture = departureRoute ? (
          typeof departureRoute === 'string' ? this.deserializeRoute(JSON.parse(departureRoute)) :
            this.deserializeRoute(departureRoute)
        ) : null;

        // Set form values
        this._formService.isDepartureHotel = this.showHotel;
        this._formService.getForm().get('search').controls.isDepartureHotel?.setValue(this.showHotel);
        this._formService.getForm().get('pickup').controls.departurePassengers?.setValue(this.selectedPassengers);
        this._formService.getForm().get('terminal').controls.departureTerminal?.setValue(this.selectedTerminal);
        this._formService.getForm().get('flights').controls.departureFlight?.setValue(this.selectedFlight);
        this._formService.getForm().get('hotels').controls.departureFlightDate?.setValue(this.selectedDate);
        this._formService.getForm().get('hotels').controls.departureDatetime?.setValue(this.selectedHotelDate);
        this._formService.getForm().get('hotels').controls.departureDatetimeForTransfer?.setValue(this.selectedDepartureDateForTransfer);
        this._formService.getForm().get('pickup').controls.departureRoute?.setValue(this.selectedShuttleBusDeparture);

        if (this.selectedShuttleBusDeparture?.startDate) {
          this._formService.departurePickup = (this.selectedShuttleBusDeparture.startDate);
        }

        if (!this.showHotel) {
          this._formService.getForm().get('parkingGroup')?.controls['departureFlight']?.setValue(this.selectedFlight);
          this._formService.getForm().get('parkingGroup')?.controls['departureDate']?.setValue(this.selectedDate);
          this._formService.getForm().get('hotels')?.controls['parkingStartDate']?.setValue(this.parkingStartDate);
        }

        this._formService.departureTerminal = this.selectedTerminal;
        this._formService.selectedDepartureFlight = this.selectedFlight;
      }

      if (this.type === 'arrival') {
        this.useFlightForArrival = this.searchData?.isArrivalByFlight ?? true;
        this.showParkingEndDate = this.searchData?.isArrivalHotel ?? true;
        const arrDateVal = this.searchData?.arrivalDate || this.searchData?.arrivalFlightDate;
        this.selectedDate = arrDateVal ? new Date(arrDateVal) : null;
        this.selectedFlight = this.searchData?.arrivalFlight;
        this.selectedTerminal = this.searchData?.arrivalTerminal;

        // Deserialize arrivalRoute back to Moment object if it comes as string
        const arrivalRoute = this.searchData?.arrivalRoute;
        this.selectedShuttleBusArrival = arrivalRoute ? (
          typeof arrivalRoute === 'string' ? this.deserializeRoute(JSON.parse(arrivalRoute)) :
            this.deserializeRoute(arrivalRoute)
        ) : null;

        // Set form values
        this._formService.isArrivalByFlight = this.useFlightForArrival;
        this._formService.getForm().get('search').controls.isArrivalByFlight?.setValue(this.useFlightForArrival);
        this._formService.getForm().get('search').controls.isArrivalHotel?.setValue(this.showParkingEndDate);
        this._formService.getForm().get('hotels').controls.arrivalDate?.setValue(this.selectedDate);
        this._formService.getForm().get('flights').controls.arrivalFlight?.setValue(this.selectedFlight);
        this._formService.getForm().get('terminal').controls.arrivalTerminal?.setValue(this.selectedTerminal);
        this._formService.getForm().get('pickup').controls.arrivalRoute?.setValue(this.selectedShuttleBusArrival);

        if (this.useFlightForArrival) {
          this._formService.getForm().get('parkingGroup')?.controls['arrivalFlight']?.setValue(this.selectedFlight);
          this._formService.getForm().get('parkingGroup')?.controls['arrivalDate']?.setValue(this.selectedDate);
        }

        if (this.selectedShuttleBusArrival?.startDate) {
          this._formService.arrivalPickup = (this.selectedShuttleBusArrival.startDate);
        }
        this._formService.arrivalTerminal = this.selectedTerminal;
        this._formService.selectedArrivalFlight = this.selectedFlight;

      }
      this.selectedParkingEndDate = this.searchData?.parkingEndDatetime ? new Date(this.searchData?.parkingEndDatetime) : null;
      this._formService.getForm().get('hotels').controls.parkingEndDatetime?.setValue(this.selectedParkingEndDate);

    } else {
      this.showHotel = false;
      this.useFlightForArrival = true;
      this.showParkingEndDate = true;
      this._formService.getForm().get('search').controls['isDepartureHotel']?.setValue(false);
      this._formService.getForm().get('search')?.controls['isArrivalHotel']?.setValue(true);
      this._formService.getForm().get('search')?.controls['isArrivalByFlight']?.setValue(true);
      this._formService.isArrivalByFlight = true;
    }
  }

  combineDateTime(date: any, time: any): Date {
    time = time.split(":")
    const combinedDate = new Date(date);
    combinedDate.setHours(parseInt(time[0]));
    combinedDate.setMinutes(parseInt(time[1]));
    combinedDate.setSeconds(0);
    combinedDate.setMilliseconds(0);
    return combinedDate;
  }

  toggleHotel(event: any) {
    const isChecked = event.target.checked;
    this.showHotel = isChecked;
    this.selectedShuttleBus = '';
    if (this.type === 'departure') {
      this._formService.isDepartureHotel = isChecked;
      this._formService.getForm().get('search').controls.isDepartureHotel?.setValue(isChecked);
      this.selectedPassengers = 0;
      this.selectedDate = null;
      this.selectedDepartureDateForTransfer = null;
      this.selectedShuttleBusDeparture = null;
      this._formService.getForm().get('terminal').controls.departureTerminal?.setValue('');
      this._formService.getForm().get('pickup').controls.departurePassengers?.setValue('');
      this._formService.getForm().get('pickup').controls.departureRoute?.setValue('');
      this._formService.getForm().get('pickup').controls.departurePickupTime?.setValue('');

      if (this.showHotel) {
        this.selectedFlight = null;
        this._formService.getForm().get('flights').controls.departureFlight?.setValue('');
        this._formService.getForm().get('flights').controls.departureFlightDate?.setValue('');
      } else {
        this.selectedHotelDate = null;
        this.selectedTerminal = '';
        this.parkingStartDate = null;
        this._formService.getForm().get('hotels').controls.parkingStartDate?.setValue('');
        this._formService.getForm().get('hotels').controls.departureDatetime?.setValue('');
        this._formService.getForm().get('hotels').controls.departureDatetimeForTransfer?.setValue('');
      }
    }
  }

  openDateDialog(): void {

    let minDate: Date | null = null;
    if (this.type === 'arrival') {
      const search = this._formService.getForm().get('search');
      const hotels = this._formService.getForm().get('hotels');

      if (search.controls.isDepartureHotel.value) {
        if (hotels.controls.departureDatetime?.value) {
          minDate = new Date(hotels.controls.departureDatetimeForTransfer.value);
        } else if (hotels.controls.departureFlightDate?.value) {
          minDate = new Date(hotels.controls.departureFlightDate.value);
        }
      }
      if (!(search.controls.isDepartureHotel?.value)) {
        if (hotels.controls.departureFlightDate.value) {
          minDate = new Date(hotels.controls.departureFlightDate.value);
        }
      }
    }

    const config = this.getDialogConfig(450);
    const dialogRef = this.dialog.open(DatepickerModalComponent, {
      maxWidth: '450px',
      width: '90%',
      position: config.position,
      height: config.height,
      data: {
        selectedDate: this.selectedDate,
        type: this.type,
        form: this._formService,
        isHotel: this.showHotel,
        hotelDate: this.selectedHotelDate,
        minDate: minDate
      }
    });

    dialogRef.componentInstance.dateSelectEvent.subscribe((date) => {
      this.selectedDate = date;
      this.selectedFlight = null;
      let formattedDate = this.formatDate(date);

      if (this.type === 'arrival') {
        if (this.useFlightForArrival) {
          this.selectedTerminal = null;
          this.selectedShuttleBusArrival = null;
        } else {
          this.selectedShuttleBusArrival = null;
          this._formService.getForm().get('pickup')?.get('arrivalRoute')?.setValue('');
          this._formService.arrivalPickup = '';

          var offsetDateStart = new Date(this.selectedDate);
          offsetDateStart.setHours(0, 0, 0, 0);
          var offsetDateEnd = new Date(this.selectedDate);
          offsetDateEnd.setHours(23, 59, 59, 999);
          this.getPlannedOrderShuttleBusTypeArrival(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
        }
        this._formService.getForm().get('hotels').controls[this.type + 'Date']?.setValue(formattedDate);
        if (this.showParkingEndDate) {
          this.selectedParkingEndDate = null;
          this._formService.getForm().get('hotels').controls['parkingEndDatetime']?.setValue('');
        }
      }
      if (this.type === 'departure') {
        this.selectedShuttleBusDeparture = null;
        this._formService.getForm().get('hotels').controls[this.type + 'FlightDate']?.setValue(formattedDate);
        this.parkingStartDate = null;
      }
    });
  }

  openHotelDateTimeDialog(type: string): void {
    let minDate: Date | null = null;
    if (type === 'parkingEnd' && this.type === 'arrival') {
      const search = this._formService.getForm().get('search');
      const hotels = this._formService.getForm().get('hotels');
      if (search.controls.isArrivalHotel?.value) {
        if (hotels.controls.arrivalDate?.value) {
          minDate = new Date(
            new Date(hotels.controls.arrivalDate?.value).getTime()
          );
        } else if (this.selectedDate instanceof Date) {
          minDate = new Date(this.selectedDate);
        }
      }
    }
    if (type === 'depTransfer' && this.type === 'departure') {
      const search = this._formService.getForm().get('search');
      const hotels = this._formService.getForm().get('hotels');
      if (search.controls.isDepartureHotel?.value) {
        if (hotels.controls.departureDatetime?.value) {
          minDate = new Date(
            new Date(hotels.controls.departureDatetime?.value).getTime() + 24 * 60 * 60 * 1000
          );
        } else if (this.selectedDate instanceof Date) {
          minDate = new Date(this.selectedDate);
        }
      }
    }

    const config = this.getDialogConfig(455);
    const dialogRef = this.dialog.open(DatepickerModalComponent, {
      maxWidth: '450px',
      width: '90%',
      disableClose: true,
      position: config.position,
      height: config.height,
      data: {
        selectedDate: type === 'parking' ? this.selectedHotelDate : (type === 'parkingEnd' ? this.selectedParkingEndDate : this.selectedDepartureDateForTransfer),
        type: this.type,
        timeSelector: true,
        form: this._formService,
        minDate: minDate,
        modalRestriction: type === 'depTransfer' ? true : false
      }
    });

    dialogRef.componentInstance.dateSelectEvent.subscribe((date) => {
      if (type === 'parking') {
        if (this.selectedDate instanceof Date && date > this.selectedDate && this.type === 'departure') {
          this.selectedDate = null;
        }
        if (this.selectedDate instanceof Date && date < this.selectedDate && this.type === 'arrival') {
          this.selectedDate = null;
        }
        if (this.selectedHotelDate instanceof Date) {
          this.selectedHotelDate = set(date, {
            hours: this.selectedHotelDate.getHours(),
            minutes: this.selectedHotelDate.getMinutes()
          })
        } else {
          this.selectedHotelDate = date
        }
        this.checkAndResetTransferFields();
      }
      else if (type === 'parkingEnd') {
        if (this.selectedParkingEndDate instanceof Date) {
          this.selectedParkingEndDate = set(date,
            { hours: this.selectedParkingEndDate.getHours(), minutes: this.selectedParkingEndDate.getMinutes() });
        } else {
          this.selectedParkingEndDate = date;
        }
      }
      else if (type === 'depTransfer') {
        if (this.selectedDepartureDateForTransfer instanceof Date) {
          this.selectedDepartureDateForTransfer = set(date, {
            hours: this.selectedDepartureDateForTransfer.getHours(),
            minutes: this.selectedDepartureDateForTransfer.getMinutes()
          })
        } else {
          this.selectedDepartureDateForTransfer = date
        }
      }
    });

    dialogRef.componentInstance.timeSelectEvent.subscribe((time) => {
      if (type === 'parking') {
        if (this.selectedHotelDate instanceof Date) {
          this.selectedHotelDate = set(this.selectedHotelDate, { hours: time.getHours(), minutes: time.getMinutes() });
        } else {
          this.selectedHotelDate = time;
        }
        let formattedDate = this.formatDate(this.selectedHotelDate);
        this._formService.getForm().get('hotels').controls.departureDatetime?.setValue(formattedDate);
        this.checkAndResetTransferFields();
      } else if (type === 'parkingEnd') {
        if (this.selectedParkingEndDate instanceof Date) {
          this.selectedParkingEndDate = set(this.selectedParkingEndDate, { hours: time.getHours(), minutes: time.getMinutes() });
        } else {
          this.selectedParkingEndDate = time;
        }
        let formattedParkingEndDate = this.formatDate(this.selectedParkingEndDate);
        this._formService.getForm().get('hotels').controls['parkingEndDatetime']?.setValue(formattedParkingEndDate);
      } else if (type === 'depTransfer') {
        this.selectedShuttleBusDeparture = null;
        if (this.selectedDepartureDateForTransfer instanceof Date) {
          this.selectedDepartureDateForTransfer = set(this.selectedDepartureDateForTransfer, { hours: time.getHours(), minutes: time.getMinutes() });
        } else {
          this.selectedDepartureDateForTransfer = time;
        }
        let formattedDateForTransfer = this.formatDate(this.selectedDepartureDateForTransfer);
        this._formService.getForm().get('hotels').controls[this.type + 'DatetimeForTransfer']?.setValue(formattedDateForTransfer);

        if (this.bookingConfigShuttleDeparture?.type == 'DEPARTURETIMETABLE') {
          let offset = 60;
          var offsetDateStart = new Date(new Date(this.selectedDepartureDateForTransfer).getTime() - offset * 60000);
          var offsetDateEnd = new Date(new Date(this.selectedDepartureDateForTransfer).getTime() + offset * 60000);
          this.getPlannedOrderShuttleBusTypeDeparture(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
        }
      }
    });
  }

  openFlightDialog() {
    if (!this.isFlightSelectEnabled) {
      return
    }
    const config = this.getDialogConfig(550);
    const dialogRef = this.dialog.open(FlightPickerModalComponent, {
      panelClass: 'pf-dateflight-picker-dialog',
      position: config.position,
      height: config.height,
      data: {
        selectedDate: this.selectedDate,
        type: this.type
      }
    });

    dialogRef.componentInstance.selectFlightEvent.subscribe((flight) => {
      this._formService.getForm().get('flights').controls[this.type + 'Flight'].setValue(flight);

      if (this.type === 'arrival') {
        this._formService.selectedArrivalFlight = flight;
        this.selectedFlight = flight;
        this.selectedShuttleBusArrival = '';
        this._formService.arrivalPickup = '';
        this.parkingStartDate = null;
        this._formService.getForm().get('hotels')?.controls['parkingStartDate']?.setValue('');
        this._formService.getForm().get('pickup')?.controls[this.type + 'Route']?.setValue('');

        if (this.bookingConfigShuttleArrival?.type == 'ARRIVALFLIGHTANDTIMETABLE') {
          let offset = this.bookingConfigShuttleArrival.shuttleDateOffsetMinutes;
          var offsetDateStart = new Date(new Date(flight.arrivalTime?.scheduled).getTime() + offset * 60000);
          var offsetDateEnd = new Date(new Date(flight.arrivalTime?.scheduled).getTime() + offset * 60000 + 3600000);
          this.getPlannedOrderShuttleBusTypeArrival(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
        }
      }

      if (this.type === 'departure') {
        this._formService.selectedDepartureFlight = flight;
        this.selectedFlight = flight;
        this.selectedShuttleBusDeparture = null;

        if (this.bookingConfigShuttleDeparture?.type == 'DEPARTURETIMETABLE') {
          var offsetDateStart = new Date(new Date(flight.departureTime?.scheduled).getTime() - 210 * 60000); // 3.5 hours before
          var offsetDateEnd = new Date(new Date(flight.departureTime?.scheduled).getTime() - 60 * 60000); // 1 hour before
          this.getPlannedOrderShuttleBusTypeDeparture(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
        }
      }

    });

    dialogRef.componentInstance.flightTimeoutEvent.subscribe(() => {
      console.warn("Flight request timed out!");
      dialogRef.close();
      this.snackBar.open(
        'Misslyckades med att hämta data. Vänligen försök igen.',
        'OK',
        {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        }
      );
    });

    dialogRef.componentInstance.noInternetEvent.subscribe(() => {
      console.warn("Check the network connection!");
      dialogRef.close();
      this.snackBar.open(
        'Ingen internetanslutning. Kontrollera din nätverksanslutning.',
        'OK',
        { duration: 5000, verticalPosition: 'top', horizontalPosition: 'center' }
      );
    });

    dialogRef.componentInstance.errorEvent.subscribe(() => {
      console.warn("Something went wrong!");
      dialogRef.close();
      this.snackBar.open(
        'Något gick fel! Vänligen försök igen.',
        'OK',
        { duration: 5000, verticalPosition: 'top', horizontalPosition: 'center' }
      );
    });
  }

  get isFlightSelectEnabled(): boolean {
    if (this.selectedDate) {
      return true;
    }
    return false;
  }

  get isParkingArrivalTimeEnabled(): boolean {
    if (this.selectedFlight) {
      return true;
    }
    return false;
  }

  setArrivedAtParking(time: any, viewValue: any, dateTime: any) {
    this.selectedTime = time;
    this.parkingArrivalTimeText = viewValue;
    if (this.type === 'arrival') {
      this._formService.searchEndDate = dateTime;
    }
    if (this.type === 'departure') {
      this._formService.searchStartDate = dateTime;
      this._formService.getForm().get('search').controls[this.type + 'Datetime']?.setValue(dateTime);
    }
  }

  fetchDepShuttleBusses() {
    if (this.plannedShuttleBussesDeparture?.length <= 0) {
      if (!this.showHotel) {
        var offsetDateStart = new Date(new Date(this.selectedFlight?.departureTime?.scheduled).getTime() - 210 * 60000); // 3.5 hours before
        var offsetDateEnd = new Date(new Date(this.selectedFlight?.departureTime?.scheduled).getTime() - 60 * 60000); // 1 hour before
        this.getPlannedOrderShuttleBusTypeDeparture(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
      } else {
        var offsetDateStart = new Date(new Date(this.selectedDepartureDateForTransfer).getTime() - 60 * 60000); // 1 hour before
        var offsetDateEnd = new Date(new Date(this.selectedDepartureDateForTransfer).getTime() + 60 * 60000); // 1 hour after
        this.getPlannedOrderShuttleBusTypeDeparture(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
      }
    }
  }

  fetchArrShuttleBusses() {
    if (this.plannedShuttleBussesArrival?.length <= 0) {
      if (this.useFlightForArrival) {
        let offset = this.bookingConfigShuttleArrival.shuttleDateOffsetMinutes;
        var offsetDateStart = new Date(new Date(this.selectedFlight?.arrivalTime?.scheduled).getTime() + offset * 60000); // 45 minutes after
        var offsetDateEnd = new Date(new Date(this.selectedFlight?.arrivalTime?.scheduled).getTime() + offset * 60000 + 3600000); // 1.75 hours after
        this.getPlannedOrderShuttleBusTypeArrival(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
      } else {
        var offsetDateStart = new Date(this.selectedDate);
        offsetDateStart.setHours(0, 0, 0, 0);
        var offsetDateEnd = new Date(this.selectedDate);
        offsetDateEnd.setHours(23, 59, 59, 999);
        this.getPlannedOrderShuttleBusTypeArrival(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
      }
    }
  }

  setShuttleBus(route: any, type: string) {
    this._formService.getForm().get('pickup')?.controls[this.type + 'Route']?.setValue(route);
    if (type === 'departure') {
      this.selectedShuttleBusDeparture = route;
      if (route?.startDate) {
        this._formService.departurePickup = this.formatDateTime(route.startDate.toDate());
        const date = route.startDate.clone();
        this.parkingStartDate = ((date).subtract(1, 'hour')).format('YYYY-MM-DDTHH:mm:ss');
        this._formService.getForm().get('hotels')?.controls['parkingStartDate']?.setValue(this.parkingStartDate);
      }
    }
    if (type === 'arrival') {
      this.selectedShuttleBusArrival = route;
      if (route?.startDate) {
        this._formService.arrivalPickup = this.formatDateTime(route.startDate.toDate());
      }
    }
  }

  setPassengers(num: number) {
    this.selectedPassengers = num;
    this._formService.getForm().get('pickup')?.controls['departurePassengers'].setValue(num);
  }

  toggleByFlightOrByTime() {
    this.selectedDate = null;
    this.selectedPassengers = this._formService.getForm().get('pickup')?.controls['departurePassengers'].value;
    this.selectedShuttleBusArrival = null;
    this._formService.getForm().get('pickup').controls.arrivalRoute?.setValue('');
    this._formService.getForm().get('pickup').controls.arrivalPickupTime?.setValue('');
    if (this.useFlightForArrival) {
      this.selectedTerminal = null;
      this._formService.getForm().get('terminal')?.controls['arrivalTerminal']?.setValue('');
    } else {
      this.selectedFlight = null;
      this._formService.getForm().get('search')?.controls['arrivalFlightDate'].setValue('');
      this._formService.getForm().get('flights')?.controls['arrivalFlight']?.setValue('');
      this._formService.getForm().get('parkingGroup')?.controls['arrivalFlight']?.setValue('');
      this._formService.getForm().get('parkingGroup')?.controls['arrivalDate']?.setValue('');
    }
    this._formService.isArrivalByFlight = this.useFlightForArrival;
    this._formService.getForm().get('search')?.controls.isArrivalByFlight?.setValue(this.useFlightForArrival);
    this._formService.getForm().get('hotels')?.controls.arrivalHotel?.setValue(this.useFlightForArrival);
  }

  setTerminal(terminal: any) {
    this.selectedTerminal = terminal;

    if (this.type === 'arrival' && this.bookingConfigShuttleArrival?.type == 'ARRIVALFLIGHTANDTIMETABLE') {
      this._formService.getForm().get('terminal').controls.arrivalTerminal?.setValue(terminal);
      this._formService.arrivalTerminal = terminal;
    }
    if (this.type === 'departure' && this.bookingConfigShuttleDeparture?.type == 'DEPARTURETIMETABLE') {
      this._formService.getForm().get('terminal').controls.departureTerminal?.setValue(terminal);
      this._formService.departureTerminal = terminal;
    }
  }

  openTimeDialog(): void {
    if (this.selectedFlight && !this.selectedHotel) {
      this.arriveAtParkingOptions = this._parkingRepo.createParkingStartTimeOptions(this.selectedFlight.departureTime?.scheduled);
    }
  }

  getPlannedOrderShuttleBusTypeDeparture(startDate: string, endDate: string) {
    this.plannedShuttleBussesDeparture = [];
    if (this.bookingConfigShuttleDeparture?.routeCode && this.bookingConfigShuttleDeparture?.shuttleTypeCode) {
      this.shuttleBussService
        .getPlannedOrderShuttleBusType(this.bookingConfigShuttleDeparture.routeCode, startDate, endDate, this.bookingConfigShuttleDeparture.shuttleTypeCode)
        .subscribe(plannedShuttleBusses => {
          plannedShuttleBusses.forEach(shuttle => {
            shuttle.startDate = moment(shuttle.startDate).isValid() ? moment(shuttle.startDate) : moment();
          });
          this.plannedShuttleBussesDeparture = plannedShuttleBusses.filter(shuttle => {
            return shuttle.startDate.isAfter(moment()) && (shuttle.seats == null
              || (shuttle.seats - shuttle.passengers >= this.selectedPassengers)
            );
          });
          if (this.plannedShuttleBussesDeparture.length < 3) {
            const newEndDate = moment(endDate).add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss');
            this.getPlannedOrderShuttleBusTypeDeparture(startDate, newEndDate);
          }
          const depDateTime = this._formService.getForm().get('hotels')?.controls['departureDatetimeForTransfer']?.value;
          const selectedMoment = moment(depDateTime);
          const matchedShuttle = this.plannedShuttleBussesDeparture.find(shuttle =>
            shuttle.startDate.isSame(selectedMoment)
          );
          if (matchedShuttle) {
            this.plannedShuttleBussesDeparture = [matchedShuttle];
            this.setShuttleBus(matchedShuttle, 'departure');
          }
        });
    }
  }

  getPlannedOrderShuttleBusTypeArrival(startDate: string, endDate: string) {
    this.selectedPassengers = this._formService.getForm().get('pickup')?.controls['departurePassengers'].value;
    this.plannedShuttleBussesArrival = [];
    if (this.bookingConfigShuttleArrival?.routeCode && this.bookingConfigShuttleArrival?.shuttleTypeCode) {
      this.shuttleBussService
        .getPlannedOrderShuttleBusType(this.bookingConfigShuttleArrival.routeCode, startDate, endDate, this.bookingConfigShuttleArrival.shuttleTypeCode)
        .subscribe(plannedShuttleBusses => {
          plannedShuttleBusses.forEach(shuttle => {
            shuttle.startDate = moment(shuttle.startDate).isValid() ? moment(shuttle.startDate) : moment();
          });
          this.plannedShuttleBussesArrival = plannedShuttleBusses.filter(shuttle => {
            return shuttle.startDate.isAfter(moment().add(20, 'm')) && (shuttle.seats == null
              || (shuttle.seats - shuttle.passengers >= this.selectedPassengers)
            );
          });
          if (this.plannedShuttleBussesArrival.length < 3) {
            const newEndDate = moment(endDate).add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss');
            this.getPlannedOrderShuttleBusTypeArrival(startDate, newEndDate);
          }
        });
    }
  }

  getOrganizationConfig(organizationId: string) {
    const bookingConfigs: BookingConfig[] = [];
    bookingConfigs.push(this.bookingConfigQuality);
    bookingConfigs.push(this.bookingConfigAiden);
    this.bookingConfig = bookingConfigs.find(f => f.organizationId === organizationId);
    this.bookingConfigType = this.bookingConfig.bookingConfigTypes.find(f => f.configType === 'HOTEL');
    this.updateShuttleConfigs();
  }

  updateShuttleConfigs() {
    this.bookingConfigType = this.bookingConfig?.bookingConfigTypes?.find(f => f.configType === 'HOTEL');
    if (!this.bookingConfigType) {
      console.error('BookingConfigType not found for HOTEL');
      return;
    }
    this.bookingConfigShuttleDeparture = this.bookingConfigType.shuttlesConfig?.find(f => f.type?.startsWith('DEPARTURE')) || null;
    this.bookingConfigShuttleArrival = this.bookingConfigType.shuttlesConfig?.find(f => f.type?.startsWith('ARRIVAL')) || null;
  }

  get departureTerminals(): any[] {
    const date = this.selectedDepartureDateForTransfer || this.selectedDate;
    return filterTerminalsByDate(this.bookingConfigShuttleDeparture?.terminals || [], date);
  }

  get arrivalTerminals(): any[] {
    const date = this.selectedDate;
    return filterTerminalsByDate(this.bookingConfigShuttleArrival?.terminals || [], date);
  }

  toggleParkingEndDate() {
    this.showParkingEndDate = !this.showParkingEndDate;
    this._formService.getForm().get('search')?.controls['isArrivalHotel']?.setValue(this.showParkingEndDate);
  }

  formatDate(sourceDate: Date): string {
    var twoDigitMonth = ((sourceDate.getMonth() + 1) >= 10) ? (sourceDate.getMonth() + 1) : '0' + (sourceDate.getMonth() + 1);
    var twoDigitDate = ((sourceDate.getDate()) >= 10) ? (sourceDate.getDate()) : '0' + (sourceDate.getDate());
    var twoDigitHour = ((sourceDate.getHours()) >= 10) ? (sourceDate.getHours()) : '0' + (sourceDate.getHours());
    var twoDigitMinute = ((sourceDate.getMinutes()) >= 10) ? (sourceDate.getMinutes()) : '0' + (sourceDate.getMinutes());
    var returnDate = sourceDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + 'T' + twoDigitHour + ':' + twoDigitMinute + ':00';
    return returnDate;
  }

  handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`handleBookingService.handleError ${errMsg}`);
    return throwError(error);
  }

  formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  deserializeRoute(route: any): any {
    if (!route) {
      return null;
    }
    return {
      ...route,
      startDate: route.startDate ? (
        typeof route.startDate === 'string' ? moment(route.startDate) :
          (route.startDate._isAMomentObject ? route.startDate : moment(route.startDate))
      ) : null,
      endDate: route.endDate ? (
        typeof route.endDate === 'string' ? moment(route.endDate) :
          (route.endDate._isAMomentObject ? route.endDate : moment(route.endDate))
      ) : null
    };
  }

  resetArrivalFields(): void {
    this.selectedDate = null;
    this.selectedFlight = null;
    this.selectedTerminal = null;
    this.selectedShuttleBusArrival = null;
    this.selectedParkingEndDate = null;
    this.plannedShuttleBussesArrival = [];

    const form = this._formService.getForm();
    if (form) {
      form.get('hotels.arrivalDate')?.setValue('');
      form.get('hotels.parkingEndDatetime')?.setValue('');
      form.get('flights.arrivalFlight')?.setValue('');
      form.get('pickup.arrivalRoute')?.setValue('');
      form.get('terminal.arrivalTerminal')?.setValue('');
    }

    this._formService.arrivalPickup = '';
    this._formService.arrivalTerminal = null;
    this._formService.selectedArrivalFlight = null;
  }

  checkAndResetArrivalFields(): void {
    if (this.type !== 'arrival') {
      return;
    }

    const form = this._formService.getForm();
    if (!form) return;
    const hotels = form.get('hotels');
    if (!hotels) return;

    const depDates: Date[] = [];
    if (hotels.get('departureFlightDate')?.value) {
      depDates.push(new Date(hotels.get('departureFlightDate').value));
    }
    if (hotels.get('departureDatetime')?.value) {
      depDates.push(new Date(hotels.get('departureDatetime').value));
    }
    if (hotels.get('departureDatetimeForTransfer')?.value) {
      depDates.push(new Date(hotels.get('departureDatetimeForTransfer').value));
    }

    let shouldReset = false;

    for (const depDate of depDates) {
      if (isNaN(depDate.getTime())) continue;

      if (this.selectedDate) {
        const arrDate = new Date(this.selectedDate);
        if (!isNaN(arrDate.getTime()) && depDate > arrDate) {
          shouldReset = true;
          break;
        }
      }

      if (this.selectedParkingEndDate) {
        const endDatetime = new Date(this.selectedParkingEndDate);
        if (!isNaN(endDatetime.getTime()) && depDate > endDatetime) {
          shouldReset = true;
          break;
        }
      }
    }

    if (shouldReset) {
      this.resetArrivalFields();
    }
  }

  checkAndResetTransferFields(): void {
    if (this.type !== 'departure') {
      return;
    }

    if (this.selectedHotelDate && this.selectedDepartureDateForTransfer) {
      if (this.selectedHotelDate.getTime() > this.selectedDepartureDateForTransfer.getTime()) {
        this.selectedDepartureDateForTransfer = null;
        this.selectedShuttleBusDeparture = null;
        this.selectedTerminal = null;
        this.plannedShuttleBussesDeparture = [];

        const form = this._formService.getForm();
        if (form) {
          form.get('hotels.departureDatetimeForTransfer')?.setValue('');
          form.get('pickup.departureRoute')?.setValue('');
          form.get('pickup.departurePickupTime')?.setValue('');
          form.get('terminal.departureTerminal')?.setValue('');
        }

        this._formService.departurePickup = '';
        this._formService.departureTerminal = null;
        this._formService.selectedDepartureFlight = null;
      }
    }
  }

  getDialogConfig(dialogHeight: number): { position: any, height: string } {
    let topPosition = undefined;
    let computedHeight = dialogHeight === 550 ? '550px' : 'auto';

    try {
      if (window.self !== window.top) {
        let iframeEl = window.frameElement as HTMLIFrameElement;
        if (!iframeEl) {
          const iframes = Array.from(window.parent.document.querySelectorAll('iframe'));
          iframeEl = iframes.find(iframe => iframe.contentWindow === window) as HTMLIFrameElement;
        }
        if (iframeEl) {
          const rect = iframeEl.getBoundingClientRect();
          const parentInnerHeight = window.parent.innerHeight;

          // Use 95% of current screen's vh (parentInnerHeight)
          const targetHeight = Math.floor(parentInnerHeight * 0.95);

          if (dialogHeight === 550) {
            computedHeight = `${targetHeight}px`;
          } else {
            // For date picker, let height be auto if screen is large enough, otherwise scale it down
            computedHeight = targetHeight < dialogHeight ? `${targetHeight}px` : 'auto';
          }

          const visibleTop = Math.max(0, -rect.top);
          const visibleBottom = Math.min(window.innerHeight, parentInnerHeight - rect.top);
          const centerY = visibleTop + (visibleBottom - visibleTop) / 2;

          const actualHeightNum = dialogHeight === 550 ? targetHeight : Math.min(dialogHeight, targetHeight);
          const topOffset = Math.max(10, centerY - (actualHeightNum / 2));
          topPosition = `${topOffset}px`;
        }
      }
    } catch (e) {
      console.warn('Could not calculate parent viewport positioning:', e);
    }

    return {
      position: topPosition ? { top: topPosition } : undefined,
      height: computedHeight
    };
  }

}
